module.exports = "/_next/static/images/img-hero-earth-b3a7370a3502e536207f2a51a932c78c.svg";